import React from 'react';
import { renderMarkdown } from '../../markdown';

/* Progress / session / utility components (registry §7–8). */

export const TutorProgressBar = ({ instance }) => {
  const { props } = instance;
  const pct = props.total ? Math.min(100, Math.round((props.current / props.total) * 100)) : 0;
  return (
    <div className="tu-progress" role="progressbar" aria-valuenow={props.current} aria-valuemax={props.total}>
      <span className="tu-progress-label">{props.label || 'Progress'}</span>
      {props.segments ? (
        <span className="tu-segs">
          {props.segments.map((s, i) => <i key={i} className={`tu-seg ${s.status}`} />)}
        </span>
      ) : (
        <span className="tu-progress-track"><i style={{ width: `${pct}%` }} /></span>
      )}
      <span className="tu-progress-count">{props.current}/{props.total}</span>
    </div>
  );
};

export const TextBubble = ({ instance }) => {
  const { props } = instance;
  return (
    <div className={`tu-bubble${props.intent ? ` ${props.intent}` : ''}`}>
      {renderMarkdown(props.markdown || '')}
    </div>
  );
};

const mColor = (m) => (m >= 0.7 ? '#10b981' : m >= 0.4 ? '#f59e0b' : '#ef4444');

export const SessionSummary = ({ instance, emit, busy }) => {
  const { props } = instance;
  const s = props.stats || {};
  const mins = Math.round((s.duration_s || 0) / 60);
  return (
    <div className="tu-card tu-summary">
      <div className="tu-summary-title">🏁 Session summary</div>
      <div className="tu-statgrid">
        <div className="tu-stat"><b>{s.questions ?? 0}</b><span>questions</span></div>
        <div className="tu-stat"><b>{s.correct ?? 0}</b><span>correct</span></div>
        <div className="tu-stat"><b>{Math.round((s.accuracy || 0) * 100)}%</b><span>accuracy</span></div>
        <div className="tu-stat"><b>{mins}m</b><span>duration</span></div>
        <div className="tu-stat"><b>{s.hints_used ?? 0}</b><span>hints</span></div>
      </div>
      {(props.mastery_deltas || []).length > 0 && (
        <div className="tu-summary-sec">
          <div className="tu-summary-h">Mastery moved</div>
          {props.mastery_deltas.map((d) => (
            <div key={d.concept_id} className="tu-delta">
              <span className="tu-delta-label">{d.label}</span>
              <span className="tu-delta-val" style={{ color: mColor(d.after) }}>
                {Math.round(d.before * 100)}% → {Math.round(d.after * 100)}%
              </span>
            </div>
          ))}
        </div>
      )}
      {(props.missed || []).length > 0 && (
        <div className="tu-summary-sec">
          <div className="tu-summary-h">Worth revisiting</div>
          <div className="tu-chips">
            {props.missed.map((m) => (
              <button key={m.question_id} type="button" className="tu-chip" disabled={busy}
                onClick={() => emit('missed_clicked', { question_id: m.question_id, concept_id: m.concept_id })}>
                ✗ {m.label}
              </button>
            ))}
          </div>
        </div>
      )}
      {(props.next_up || []).length > 0 && (
        <div className="tu-summary-sec">
          <div className="tu-summary-h">Next up</div>
          <div className="tu-chips">
            {props.next_up.map((n) => (
              <button key={n.concept_id} type="button" className="tu-chip action" disabled={busy}
                title={n.reason}
                onClick={() => emit('next_up_clicked', { concept_id: n.concept_id })}>
                → {n.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
